import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Unpaid = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M27 5.93799H5C3.35 5.93799 2 7.28799 2 8.93799V22.938C2 24.588 3.35 25.938 5 25.938H27C28.65 25.938 30 24.588 30 22.938V8.93799C30 7.28799 28.65 5.93799 27 5.93799V5.93799ZM22.075 23.938H9.925C9.487 20.875 7.063 18.45 4 18.013V13.863C7.063 13.425 9.487 11.001 9.925 7.93799H22.075C22.513 11.001 24.938 13.425 28 13.863V18.013C24.937 18.451 22.512 20.876 22.075 23.938ZM28 8.93799V11.838C26.05 11.438 24.5 9.89999 24.1 7.93799H27C27.55 7.93799 28 8.38799 28 8.93799ZM5 7.93799H7.9C7.5 9.88799 5.95 11.438 4 11.838V8.93799C4 8.38799 4.45 7.93799 5 7.93799V7.93799ZM4 22.938V20.038C5.95 20.438 7.5 21.976 7.9 23.938H5C4.45 23.938 4 23.488 4 22.938ZM27 23.938H24.1C24.5 21.988 26.038 20.438 28 20.038V22.938C28 23.488 27.55 23.938 27 23.938Z" />
		<path d="M17.413 16L19.701 13.713C19.876 13.538 19.989 13.288 19.989 13C19.989 12.45 19.539 12 18.989 12C18.714 12 18.464 12.113 18.277 12.287L16.002 14.587L13.715 12.3C13.54 12.125 13.29 12.013 13.002 12.013C12.452 12.013 12.002 12.463 12.002 13.013C12.002 13.288 12.115 13.538 12.289 13.726L14.576 16.013L12.289 18.301C12.114 18.476 12.002 18.726 12.002 19.013C12.002 19.563 12.452 20.013 13.002 20.013C13.277 20.013 13.527 19.9 13.715 19.725L16.002 17.437L18.29 19.725C18.465 19.9 18.715 20.013 19.002 20.013C19.552 20.013 20.002 19.563 20.002 19.013C20.002 18.738 19.889 18.488 19.714 18.301L17.414 16.001L17.413 16Z" />
	</svg>
);

export default Unpaid;
